// NAOMI feature flags — flip manually (true = on, false = off).
export const FEATURE_FLAGS = {
  naomi_mapping_enable: true,
};
